<template>
    <div class="mx-auto col-lg-6 col-md-8 col-sm-12 header-margin">
        <div class="text-center p-2">
            <h3>{{ $t('aube-coin.forthing.detail.title-label') }}</h3>
        </div>

        <div v-if="(! detail) && (! transactions)">
            <p class="card-text m-0 p-0 mt-2 pb-4">
                {{ $t('loading') }}
            </p>
        </div>

        <div class ="container center-items" v-if="(detail) && (transactions)">
            <div class="container center-items m-0 p-0">
                <div class="card card-pricing text-center p-0 m-0 mt-4 overflow-hidden">
                    <div
                        v-bind:class="{
                            'bg-primary'  : (detail.is_active_forthing),
                            'bg-secondary': (! (detail.is_active_forthing))
                        }"
                    >
                        <span
                            class="h6 font-weight-normal w-60 mx-auto px-4 rounded-bottom bg-white shadow-sm"
                            v-bind:class="{
                                'text-primary'  : (detail.is_active_forthing),
                                'text-secondary': (! (detail.is_active_forthing))
                            }"
                        >{{ $t('aube-coin.forthing.detail.sub-title-label') }}</span>
                        <span class="h3 text-white d-block my-4">
                            {{
                                (detail.is_active_forthing) ?
                                $t('aube-coin.forthing.detail.status-labels.on') :
                                $t('aube-coin.forthing.detail.status-labels.off')
                            }}
                        </span>
                    </div>

                    <div class="card-body p-0 m-0">
                        <span class="h5 font-weight-bold text-black text-center d-block m-0 mt-4">
                            {{ $t('aube-coin.forthing.detail.total-label') }}
                        </span>
                        <span class="h4 font-weight-normal text-black text-center d-block m-0 mt-0">
                            {{ detail.total_amount | round }} AUBE
                        </span>

                        <span class="h5 font-weight-bold text-black text-center d-block m-0 mt-4">
                            {{ $t('aube-coin.forthing.detail.confirmed-amount-label') }}
                        </span>
                        <span class="h4 font-weight-normal text-black text-center d-block m-0 mt-0">
                            {{ detail.confirmed_amount | round }} AUBE
                        </span>

                        <span class="h5 font-weight-bold text-black text-center d-block m-0 mt-4">
                            {{ $t('aube-coin.forthing.detail.unconfirmed-amount-label') }}
                        </span>
                        <span class="h4 font-weight-normal text-black text-center d-block m-0 mt-0 mb-4">
                            {{ detail.unconfirmed_amount | round }} AUBE
                        </span>

                        <span class="text-black text-right d-block m-0 mt-4" style="padding-right: 10px;">
                            <div v-if="detail.next_confirmation_date">
                                <div>{{ $t('aube-coin.forthing.detail.next-confirmation-date') }}{{ detail.next_confirmation_date | moment('YYYY/MM/DD') }}</div>
                            </div>
                            <div v-else>
                                <div>{{ $t('aube-coin.forthing.detail.next-confirmation-date') }}&ensp;&ensp;-&ensp;&ensp;</div>
                            </div>
                        </span>
                    </div>

                    <div class="card-footer m-0 py-1">
                        <span class="font-weight-normal text-black text-center d-block">
                            Update: {{ detail.updated_at | moment('YYYY/MM/DD HH:mm:ss') }} (SGT)
                        </span>
                    </div>
                </div>
            </div>

            <div class="container center-items m-0 p-0 mt-5">
                <table class="table table-striped forthing-table">
                    <thead>
                        <tr class="bg-primary">
                            <th scope="col" class="text-left text-white border-0">
                                {{ $t('aube-coin.forthing.detail.date-label') }}
                            </th>
                            <th scope="col" class="text-left text-white border-0">
                                {{ $t('aube-coin.forthing.detail.volume-label') }}
                            </th>
                            <th scope="col" class="text-left text-white border-0">
                                {{ $t('aube-coin.forthing.detail.paid-label') }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="transaction in transactions" v-bind:key="transaction.id">
                            <td class="text-left">
                                {{ transaction.created_at | moment('YYYY/MM/DD') }} (SGT)
                            </td>
                            <td class="text-left">
                                {{ transaction.amount | round }}
                            </td>
                            <td class="text-center text-success">
                                <div v-if="transaction.status === 'claimed'">
                                    <div v-if="transaction.claim_type === 'AUTO'">
                                        <i class="fa fa-check-circle fa-lg aube_stake_check_color"></i>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="container center-items text-center m-0 p-0 mt-5">
                <router-link :to="{ name: 'aube-coin-forthing-history' }" class="btn btn-primary forthing-history-button-label">
                    {{ $t('aube-coin.forthing.detail.history-button-label') }}
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    import UserService from './../../services/UserService';
    import Forthing2Service from './../../services/Forthing2Service';

    export default {
        name: 'AubeCoinBalances',

        components: {
        },

        data() {

            return {
                detail: {
                    is_active_forthing: false,
                    total_amount: '0.000000000000000000',
                    confirmed_amount: '0.000000000000000000',
                    unconfirmed_amount: '0.000000000000000000',
                    next_confirmation_date: null,
                    created_at: null,
                    updated_at: null,
                },
                transactions: [],
                isChild: true,
            }
        },

        async mounted() {
            await this.fetchUserFrontendData();

            if (this.isChild) {
                await this.$router.push('/settings');
                return;
            }
            await this.fetch();
        },

        created() {

        },

        methods: {
            async fetchUserFrontendData() {
                const data = (await UserService.getUserFrontendData()).data;
                this.isChild = data.is_child;
                this.member_type_id = data.member_type_id;
            },
            async fetch() {
                // Forthing2 API を呼び出し
                let [ detail, transactions ] = await Promise.all([
                    Forthing2Service.getForthingDetail(),
                    Forthing2Service.getForthingLatestTransactions(),
                ]);

                // Forthing2 API のレスポンス構造に対応
                this.detail = detail.data;
                
                // トランザクションデータの処理
                // Forthing2 API は { data: [], meta: { pagination: {...} } } 形式で返す
                if (transactions.data && transactions.data.data) {
                    this.transactions = transactions.data.data;
                } else if (Array.isArray(transactions.data)) {
                    this.transactions = transactions.data;
                }
            }
        }
    }
</script>

<style scoped>
    .forthing-table {
        border-collapse: separate;
        border: 1px solid rgba(0, 0, 0, 0.125);
        border-radius: 0.25rem;
        overflow: hidden;
    }
    .center-items {
        width: 100%;
        margin: 0 auto;
    }
    .forthing-history-button-label {
        white-space: nowrap;
    }
    .aube_user_wallet_check_color {
        color: #450080;
    }
    .aube_stake_check_color {
        color: #00ad69;
    }
</style>
